import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React from "react";
import { Link } from "react-router-dom";
import Head from "../../components/common/Head";
import ContentTable from "../../components/movies/Table";
import useValidate from "../../hooks/useValidate";
import { getAllGenres, getAllSoon } from "../../utils/api";
import useStore from "../../utils/store";

const CommingSoon = () => {
  const user = useStore((state) => state.user);
  
  const [movies, setMovies] = React.useState([]);
  const [genres, setGenres] = React.useState([]);
  const [update, setUpdate] = React.useState({});
  const [modal2, setModal2] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [modal, setModal] = React.useState(false);
  const getAllMoviesData = async () => {
    setLoading(true);
    const [success, response] = await getAllSoon();
    if (success) setMovies(response);
    setLoading(false);
  };

  const getAllGenresData = async () => {
    setLoading(true);
    const [success, response] = await getAllGenres();
    if (success) setGenres(response);
    setLoading(false);
  };
  useValidate();
  React.useEffect(() => {
    getAllMoviesData();
    getAllGenresData();
  }, []);
  return (
    <>
      
      <Head
        title="Coming Soon"
        customButton={
          user?.addComingSoon ? (
            <Link to="/coming-soon/add">
              <Button>Add</Button>
            </Link>
          ) : null
        }
      />
      {user?.getAllComingSoon && (
        <ContentTable
          data={movies}
          loading={loading}
          setModal2={setModal2}
          reload={getAllMoviesData}
          setUpdate={setUpdate}
          coming
          permissions={{
            updateComingSoon: user?.updateComingSoon,
            deleteComingSoon: user?.deleteComingSoon,
          }}
        />
      )}
    </>
  );
};

export default CommingSoon;
